<script lang="ts">
  import type { SettlementDetails } from "../types";
  import Lock from "~icons/ph/lock-bold";
  import FooterButtons from "../../../components/workflow/FooterButtons.svelte";
  import ContinueButton from "../../../components/workflow/ContinueButton.svelte";
  import OfferBreakdown from "../elements/OfferBreakdown.svelte";
  import {
    FaqHowCalculated,
    FaqWhenPayment,
    FaqHowPayment,
    FaqMultipleSettlements,
    FaqWhyFees,
    FaqNotAccept,
    FaqTaxable,
  } from "../faqs/Faq";
  import DownloadLink from "../../Settlement/elements/DownloadLink.svelte";
  import CloseButton from "../../../components/CloseButton.svelte";

  let {
    opposingPartyName,
    settlementDetails,
    jlgMainPhone,
    offerAccepted,
  }: {
    opposingPartyName: string;
    settlementDetails: SettlementDetails;
    jlgMainPhone: string;
    offerAccepted: boolean;
  } = $props();
</script>

<h2 class="ui-title mb-6">Your {opposingPartyName} offer details</h2>

<OfferBreakdown {settlementDetails}>
  <div class="ui-alert ui-alert-success">
    <Lock />
    Your claim is protected by the SRA fee cap.
  </div>
</OfferBreakdown>

<h3 class="ui-section-title mb-4">Have questions?</h3>

<div class="ui-accordion">
  <FaqHowCalculated />
  <FaqWhenPayment />
  <FaqHowPayment phone={jlgMainPhone} />
  <FaqMultipleSettlements />
  <FaqWhyFees gross={settlementDetails.grossSettlementAmount} />
  <FaqNotAccept phone={jlgMainPhone} />
  <FaqTaxable />
</div>

{#if offerAccepted}
  <DownloadLink label="Download statute bill" href={settlementDetails.statuteBillUrl} class="mb-4" />
  <DownloadLink label="Download letter of advice" href={settlementDetails.letterOfAdviceUrl} />
{/if}

<FooterButtons back={false}>
  <CloseButton />
  <ContinueButton type="button" />
</FooterButtons>
